import React from 'react';
import { Helmet } from "react-helmet-async";
import './service.css';
import ServiceHeader from './serviceheader/ServiceHeader';
import ServiceHeaderText from './serviceheadertext/ServiceHeaderText';
import ServiceQuadSection from './servicequadsection/ServiceQuadSection';
import ServiceOurConcept from './serviceourconcept/ServiceOurConcept';

const Service = () => {
    return (
        <>
            <Helmet>
                <title>Service och driftsäkerhet | Cycle Solutions</title>
                <meta
                    name="description"
                    content="Service och driftsäkerhet från Cycle Solutions säkrar din avfallshantering. Förebyggande underhåll, snabb support och reservdelar minskar driftstopp."
                />
                <link
                    rel="canonical"
                    href="https://cyclesolutions.se/service"
                />
            </Helmet>

            <div className='service'>
                <ServiceHeader />
                <ServiceHeaderText />
                <ServiceQuadSection />
                <ServiceOurConcept />
            </div>
        </>
    );
};

export default Service;
